import {
  Box,
  Container,
  Heading,
  List,
  ListIcon,
  ListItem,
  SimpleGrid,
  Text,
  VStack,
  Card,
  CardBody,
  Button,
} from '@chakra-ui/react'
import { Link as RouterLink } from 'react-router-dom'
import { FiCheckCircle } from 'react-icons/fi'

export const RoleScenariosPage: React.FC = () => {
  return (
    <Container maxW="container.xl" py={8}>
      <VStack align="stretch" spacing={7}>
        <Box>
          <Heading as="h1" size="2xl" color="brand.500" mb={3}>
            🧭 Сценарии работы по ролям
          </Heading>
          <Text color="gray.600" fontSize="lg">
            Короткие пошаговые сценарии: что делать в течение рабочего дня для каждой роли.
          </Text>
        </Box>

        <SimpleGrid columns={{ base: 1, lg: 3 }} spacing={4}>
          <Card>
            <CardBody>
              <Heading size="md" mb={3}>Наблюдатель (V)</Heading>
              <List spacing={2}>
                <ListItem><ListIcon as={FiCheckCircle} color="green.500" />Откройте «График работ» в режиме просмотра.</ListItem>
                <ListItem><ListIcon as={FiCheckCircle} color="green.500" />Проверьте период (дата начала/конца).</ListItem>
                <ListItem><ListIcon as={FiCheckCircle} color="green.500" />Убедитесь, что по объектам всё отражено корректно.</ListItem>
                <ListItem><ListIcon as={FiCheckCircle} color="green.500" />При несоответствии сообщите менеджеру/руководителю.</ListItem>
              </List>
            </CardBody>
          </Card>

          <Card>
            <CardBody>
              <Heading size="md" mb={3}>Менеджер (M)</Heading>
              <List spacing={2}>
                <ListItem><ListIcon as={FiCheckCircle} color="green.500" />Откройте «График работ» в режиме редактирования.</ListItem>
                <ListItem><ListIcon as={FiCheckCircle} color="green.500" />Обновите блоки работ на текущую/следующую неделю.</ListItem>
                <ListItem><ListIcon as={FiCheckCircle} color="green.500" />Проверьте назначение бригад и объекты по каждому блоку.</ListItem>
                <ListItem><ListIcon as={FiCheckCircle} color="green.500" />Сформируйте отчёт по итогам периода.</ListItem>
              </List>
            </CardBody>
          </Card>

          <Card>
            <CardBody>
              <Heading size="md" mb={3}>Руководитель (L)</Heading>
              <List spacing={2}>
                <ListItem><ListIcon as={FiCheckCircle} color="green.500" />Проверьте график (включая режим с временем при необходимости).</ListItem>
                <ListItem><ListIcon as={FiCheckCircle} color="green.500" />Проверьте ключевые настройки таблицы.</ListItem>
                <ListItem><ListIcon as={FiCheckCircle} color="green.500" />Контролируйте склад: резервы, выдачи, дефицит.</ListItem>
                <ListItem><ListIcon as={FiCheckCircle} color="green.500" />Проверьте итоговые отчёты и передайте в работу команде.</ListItem>
              </List>
            </CardBody>
          </Card>
        </SimpleGrid>

        <Box>
          <Heading size="md" mb={3}>Быстрые переходы</Heading>
          <Button as={RouterLink} to="/schedule" mr={3} variant="outline">График работ</Button>
          <Button as={RouterLink} to="/warehouse" mr={3} variant="outline">Склад</Button>
          <Button as={RouterLink} to="/settings" variant="outline">Настройки и отчёты</Button>
        </Box>
      </VStack>
    </Container>
  )
}
